import React, { Component } from 'react';
import styles from './OrderForm.css';
import fire from '../../fire';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faShoppingCart } from '@fortawesome/free-solid-svg-icons';

export default class OrderForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      streetAddress: '', houseNumber: '', paymentMethod: '',
      phoneNumber: '', price: '', quantity: 0, order: 0
    };
    this.handleInputChange = this.handleInputChange.bind(this);
  }

  handleInputChange(e) {
    const target = e.target;
    const name = target.name;
    this.setState({ [name]: target.value })
  }

  handleSubmit(e) {
    e.preventDefault();
    fire.database().ref('orders').push(`STREETADDRESS: ${this.state.streetAddress}
    HOUSENUMBER: ${this.state.houseNumber}
    PAYMENTMETHOD: ${this.state.paymentMethod}
    PHONENUMBER: ${this.state.phoneNumber}
    ORDERS: ${this.state.order}
    PRICE: ${this.state.price}`,
    error => { error ? alert(`There was an error:\n${error}`) : alert(`Your food has been ordered`) })
    document.getElementById('orderForm').reset();
  }

  render() {
    return (
      <div className={styles.orderForm}>
        <form id='orderForm' onSubmit={this.handleSubmit.bind(this)}>
          Street address
        <input name='streetAddress' type='text' autoComplete='on' required placeholder='Enter your street address' onChange={this.handleInputChange} />
          House number
        <input name='houseNumber' type='text' autoComplete='on' required placeholder='Enter your house number' onChange={this.handleInputChange} />
          <div className={styles.radioButtons}>
            Payment method
          <input name='paymentMethod' id={styles.cash} type='radio' required value='Cash' onChange={this.handleInputChange} />
            <label for='cash'>Cash</label>
            <input name='paymentMethod' id={styles.debit} type='radio' required value='Debit card' />
            <label for='debit'>Debit Card </label>
          </div>
          Phone Number
        <input name='phoneNumber' type='text' required autoComplete='on' placeholder='Enter your phone number' onChange={this.handleInputChange} />
          Orders
          <textarea id={styles.orderArea} name='order' type='textarea' readOnly onChange={this.handleInputChange} required/>
          <div id={styles.quantityPrice}>
            Quantity<input name='quantity' type='text' readOnly onChange={this.handleInputChange} />
            Price<input name='price' type='text' readOnly onChange={this.handleInputChange} />
          </div>
          <button type='submit' value='submit'>Order {<FontAwesomeIcon icon={faShoppingCart} size='xl' />}</button>
        </form>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/OrderForm/OrderForm.js